import { Input, Select } from 'antd'
import { withAccessRestriction } from './withAccessRestriction'

export const RestrictedInput = withAccessRestriction(Input)
export const RestrictedSelect = withAccessRestriction(Select)
